import { render, staticRenderFns } from "./membersList.vue?vue&type=template&id=3b96037e&"
import script from "./membersList.vue?vue&type=script&lang=js&"
export * from "./membersList.vue?vue&type=script&lang=js&"
import style0 from "./membersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports